import api from '../../../services/api';
type DimensionValue = number | string | null;
export interface SupplierDraftLine {
  id: string; name: string; quantity: number; unit: string; covered: boolean;
  /** In the line unit: what live ZD items buy and the rest still to order (a line can be split, migration 212). */
  coveredQuantity?: number; remainingQuantity?: number;
  // Display only: line dimensions with the catalog (effective variant logistics) fallback.
  width?: DimensionValue; height?: DimensionValue; length?: DimensionValue; thickness?: DimensionValue;
  catalogProductWidth?: DimensionValue; catalogProductHeight?: DimensionValue;
  catalogProductLength?: DimensionValue; catalogProductThickness?: DimensionValue;
  productCategoryDimensionDisplayProfile?: string | null;
}
export interface SupplierDraftGroup {
  key: string; categoryId: string | null; name: string;
  defaultSupplierId: string | null; supplierChoiceRequired: boolean; lines: SupplierDraftLine[];
}
export interface SupplierDraftPreview {
  orderId: string; version: string; groups: SupplierDraftGroup[]; blockedReason: string | null;
  existing: Array<{ sourceOrderProductId: string | null; name: string; quantity: number; unit: string;
    supplierOrderId: string; supplierOrderNumber: string;
    currentQuantity: number | null; currentUnit: string | null }>;
  legacy: Array<{ id: string; number: string }>;
  created?: Array<{ id: string; number: string; supplierName: string }>;
}
export async function fetchSupplierDraftPreview(orderId: string): Promise<SupplierDraftPreview> {
  return (await api.get<SupplierDraftPreview>(`/orders/${orderId}/supplier-drafts`)).data;
}
/** „Podziel na dostawców”: parts of one line in its unit; their sum may stay below the rest. */
export interface SupplierDraftSplit { lineId: string; parts: Array<{ supplierId: string; quantity: number }> }
export async function createGroupedSupplierDrafts(orderId: string, version: string, groups: Array<{ key: string; supplierId: string }>, splits: SupplierDraftSplit[] = []): Promise<SupplierDraftPreview> {
  return (await api.post<SupplierDraftPreview>(`/orders/${orderId}/supplier-drafts`, splits.length ? { version, groups, splits } : { version, groups })).data;
}
